import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import WhatsAppAnimator from './pages/WhatsAppAnimator';
import Header from './components/common/Header';
import './App.css';

// Create a theme with WhatsApp colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#128C7E', // WhatsApp primary green
      light: '#25D366',
      dark: '#075E54',
    },
    secondary: {
      main: '#34B7F1', // WhatsApp secondary blue
    },
    background: {
      default: '#f0f2f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/whatsapp-animator" element={<WhatsAppAnimator />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
